import React, { useState } from "react";
import axios from "axios";
import { useVipStore } from "../context/VipContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function VipDuty() {
  const { selectedVip, handleBack } = useVipStore();
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Responsive
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 991;

  // DUTY COMPLETE API CALL (UNCHANGED)
  const handleDutyComplete = async () => {
    const confirm = window.confirm(
      "Are you sure you want to mark this duty as COMPLETED? & Please give your your Valuable Feedback!"
    );

    if (!confirm) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("vipToken");
      if (!token) {
        toast.error("Token not found. Please login again.");
        return;
      }

      const res = await axios.post(
        `${BASE_URL}/api/assignments/complete/vip/${selectedVip.id}/completed`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Duty marked as Completed Successfully!");
      console.log("API Response:", res.data);
    } catch (err) {
      console.error("Duty Complete Error:", err);
      toast.error("Failed to complete duty");
    } finally {
      setLoading(false);
    }
  };

  // NOT COMPLETE (UNCHANGED - currently commented)
  const handleDutyNotComplete = () => {
    toast.info("Duty marked as Not Completed");
  };

  // NO VIP SELECTED
  if (!selectedVip) {
    return (
      <div className="no-vip-card">
        <i className="fas fa-user-shield fa-3x"></i>
        <h3>No VIP Selected</h3>
        <p>Please select a VIP first.</p>
      </div>
    );
  }

  return (
    <>
      <div className="vip-duty-wrapper">
        {/* Header */}
        <header className="page-header">
          <div className="header-content">
            <div className="header-title">
              <h1>VIP Duty Status</h1>
              <p>Manage the current security assignment for {selectedVip.name}</p>
            </div>
            <button onClick={handleBack} className="back-btn">
              <i className="fas fa-arrow-left"></i>
              <span className="btn-text">Back</span>
            </button>
          </div>
        </header>

        {/* Main Content */}
        <main className="page-main">
          {/* VIP Info Card */}
          <section className="vip-info-card">
            <div className="vip-details">
              <h2 className="vip-name">{selectedVip.name}</h2>
              <p className="vip-id">VIP ID: {selectedVip.id}</p>
            </div>
          </section>

          {/* Instructions Card */}
          <section className="instructions-card">
            <h3 className="instruction-title">
              <i className="fas fa-clipboard-list"></i> Duty Completion Instructions
            </h3>
            <ul className="instruction-list">
              <li>
                <strong>Duty Completed:</strong> Click the green button when the VIP duty is finished successfully.
              </li>
              <li>
                <strong>Final Action:</strong> Once confirmed, the duty status becomes <strong>Inactive</strong> and cannot be changed again.
              </li>
              <li>
                <strong>Processing:</strong> Please wait while the system updates the status.
              </li>
              <li>
                <strong>Confirmation:</strong> You will be asked to confirm before marking as completed.
              </li>
            </ul>
          </section>

          {/* Action Buttons */}
          <section className="action-section">
            <button
              onClick={handleDutyComplete}
              disabled={loading}
              className="complete-btn"
            >
              {loading ? (
                <>
                  <div className="spinner-small"></div> Processing...
                </>
              ) : (
                <>
                  <i className="fas fa-check-circle"></i> Duty Completed
                </>
              )}
            </button>

            {/* Uncomment if you re-enable Not Completed */}
            {/* <button
              onClick={handleDutyNotComplete}
              disabled={loading}
              className="not-complete-btn"
            >
              <i className="fas fa-times-circle"></i> Not Completed
            </button> */}
          </section>
        </main>
      </div>

      {/* Light Purple Glassmorphic Theme */}
      <style jsx>{`
        .vip-duty-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #e0d4ff 0%, #f0e6ff 100%);
          color: #4c1d95;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
        }

        .page-header {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(168, 85, 247, 0.4);
          padding: 1.2rem 2rem;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-content {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .header-title h1 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #9333ea;
          margin: 0;
        }

        .header-title p {
          margin: 0.25rem 0 0;
          opacity: 0.8;
          font-size: 0.95rem;
          color: #6b46c1;
        }

        .back-btn {
          background: #9333ea;
          color: white;
          border: none;
          padding: 0.7rem 1.4rem;
          border-radius: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.6rem;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .back-btn:hover {
          background: #7c3aed;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(168, 85, 247, 0.3);
        }

        .page-main {
          padding: 1.5rem 2rem;
          max-width: 1000px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 1.8rem;
        }

        @media (max-width: 768px) {
          .page-main { padding: 1rem; }
          .page-header { padding: 1rem 1.5rem; }
        }

        .vip-info-card {
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          padding: 2rem;
          border: 1px solid rgba(168, 85, 247, 0.5);
          transition: all 0.3s ease;
          text-align: center;
        }

        .vip-info-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(168, 85, 247, 0.25);
        }

        .vip-name {
          font-size: 2rem;
          font-weight: 800;
          color: #581c87;
          margin: 0 0 0.5rem 0;
        }

        .vip-id {
          font-size: 1.1rem;
          color: #7c3aed;
          opacity: 0.9;
          margin: 0;
        }

        .instructions-card {
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          padding: 2rem;
          border: 1px solid rgba(168, 85, 247, 0.5);
          transition: all 0.3s ease;
        }

        .instructions-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(168, 85, 247, 0.25);
        }

        .instruction-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #6b21a8;
          margin-bottom: 1.2rem;
          display: flex;
          align-items: center;
          gap: 0.8rem;
        }

        .instruction-list {
          list-style: none;
          padding: 0;
          margin: 0;
          font-size: 1.05rem;
          line-height: 1.8;
          color: #4c1d95;
        }

        .instruction-list li {
          padding: 0.8rem 0;
          border-bottom: 1px dashed rgba(168, 85, 247, 0.3);
          display: flex;
          align-items: flex-start;
          gap: 0.8rem;
        }

        .instruction-list li:last-child {
          border-bottom: none;
        }

        .instruction-list strong {
          color: #9333ea;
        }

        .action-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .complete-btn,
        .not-complete-btn {
          padding: 1.2rem 2.5rem;
          font-size: 1.2rem;
          font-weight: 700;
          color: white;
          border: none;
          border-radius: 16px;
          cursor: pointer;
          min-width: 300px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .complete-btn {
          background: #10b981;
        }

        .complete-btn:hover:not(:disabled) {
          background: #059669;
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(16, 185, 129, 0.4);
        }

        .not-complete-btn {
          background: #ef4444;
        }

        .not-complete-btn:hover:not(:disabled) {
          background: #dc2626;
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(239, 68, 68, 0.4);
        }

        .complete-btn:disabled,
        .not-complete-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .spinner-small {
          width: 20px;
          height: 20px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .no-vip-card {
          text-align: center;
          padding: 5rem 2rem;
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          margin: 2rem;
          border: 1px solid rgba(168, 85, 247, 0.5);
          color: #9333ea;
        }

        .no-vip-card i {
          margin-bottom: 1.5rem;
          opacity: 0.6;
        }

        .no-vip-card h3 {
          font-size: 1.6rem;
          margin-bottom: 0.8rem;
        }

        .no-vip-card p {
          opacity: 0.8;
          font-size: 1.1rem;
        }
      `}</style>
    </>
  );
}

// //-----------------------------------------------2-----------------------------

// import React, { useState } from "react";
// import axios from "axios";
// import { useVipStore } from "../context/VipContext";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export default function VipDuty() {
//   const { selectedVip, handleBack } = useVipStore();
//   const [loading, setLoading] = useState(false);

//   //  DUTY COMPLETE API CALL (UNCHANGED)
//   const handleDutyComplete = async () => {
//     const confirm = window.confirm(
//       "Are you sure you want to mark this duty as COMPLETED?"
//     );

//     if (!confirm) return;

//     try {
//       setLoading(true);
//       const token = localStorage.getItem("vipToken");
//       if (!token) {
//         toast.error("Token not found. Please login again.");
//         return;
//       }

//       const res = await axios.post(
//         `${BASE_URL}/api/assignments/complete/vip/${selectedVip.id}/completed`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       toast.success(" Duty marked as Completed Successfully!");
//       console.log("API Response:", res.data);
//     } catch (err) {
//       console.error("Duty Complete Error:", err);
//       toast.error("❌ Failed to complete duty");
//     } finally {
//       setLoading(false);
//     }
//   };

//   //  NOT COMPLETE (UNCHANGED)
//   const handleDutyNotComplete = () => {
//     toast.info("❗ Duty marked as Not Completed");
//   };

//   //  NO VIP SELECTED (UNCHANGED)
//   if (!selectedVip) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.card}>
//           <h3>No VIP Selected</h3>
//           <p>Please select a VIP first.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.pageContainer}>
//       {/* HEADER */}
//       <div style={styles.header}>
//         <h2 style={styles.headerTitle}>VIP Duty Status</h2>
//         <button onClick={handleBack} style={styles.backBtn}>
//           ⬅ Back
//         </button>
//       </div>

//       {/* VIP INFO CARD */}
//       <div style={styles.card}>
//         <div style={styles.vipRow}>
//           <div>
//             <h3 style={styles.vipName}>{selectedVip.name}</h3>
//             <p style={styles.vipId}>VIP ID: {selectedVip.id}</p>
//           </div>
//          <div style={styles.instructionsCard}>
//   <h3 style={styles.instructionTitle}>📋 Duty Completion Instructions</h3>

//   <ul style={styles.instructionList}>
//     <li>
//        <strong>Duty Completed:</strong> Click when the VIP duty is finished
//       successfully.
//     </li>

//     <li>
//       ❌ <strong>Not Completed:</strong> Click if the duty could not be completed
//       due to any issue.
//     </li>

//     <li>
//       🔒 <strong>Final Action:</strong> Once a button is clicked, the duty status
//       becomes <strong>Inactive</strong> and cannot be changed again.
//     </li>

//     <li>
//       🔄 <strong>Processing:</strong> Please wait while the system updates the
//       duty status.
//     </li>

//     <li>
//       ⚠️ <strong>Confirmation Required:</strong> The system will ask for
//       confirmation before marking the duty as completed.
//     </li>
//   </ul>
// </div>
//         </div>
//       </div>

//       {/* ACTION BUTTONS */}
//       <div style={styles.actionBox}>
//         <button
//           style={{ ...styles.actionBtn, background: "#22c55e" }}
//           onClick={handleDutyComplete}
//           disabled={loading}
//         >
//           {loading ? "Processing..." : " Duty Completed"}
//         </button>

//         {/* <button
//           style={{ ...styles.actionBtn, background: "#ef4444" }}
//           onClick={handleDutyNotComplete}
//           disabled={loading}
//         >
//           ❌ Not Completed
//         </button> */}
//       </div>
//     </div>
//   );
// }

// /* ===================== MODERN UI STYLES ===================== */

// const styles = {
//   pageContainer: {
//     padding: "30px",
//     minHeight: "100vh",
//     background: "rgba(255,255,255,0.15)",
//     backdropFilter: "blur(6px)",
//   },

//   container: {
//     padding: "20px",
//     maxWidth: "700px",
//     margin: "auto",
//     fontFamily: "sans-serif",
//   },

//   header: {
//     marginBottom: "25px",
//     padding: "20px",
//     background: "linear-gradient(135deg, #4e54c8, #8f94fb)",
//     borderRadius: "14px",
//     color: "white",
//     boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },

//   headerTitle: {
//     margin: 0,
//     fontSize: "26px",
//     fontWeight: "700",
//   },

//   backBtn: {
//     padding: "10px 18px",
//     borderRadius: "10px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: "600",
//     background: "#111827",
//     color: "white",
//   },

//   card: {
//     background: "rgba(255,255,255,0.55)",
//     borderRadius: "18px",
//     padding: "25px",
//     backdropFilter: "blur(8px)",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//   },

//   vipRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },

//   vipName: {
//     fontSize: "22px",
//     fontWeight: "700",
//     margin: 0,
//   },

//   vipId: {
//     fontSize: "15px",
//     color: "#555",
//     marginTop: "6px",
//   },

//   statusBadge: {
//     padding: "8px 18px",
//     borderRadius: "20px",
//     fontWeight: "700",
//     color: "white",
//     background: "#22c55e",
//   },

//   actionBox: {
//     marginTop: "40px",
//     display: "flex",
//     gap: "20px",
//     justifyContent: "center",
//     flexWrap: "wrap",
//   },

//   actionBtn: {
//     padding: "16px 32px",
//     fontSize: "16px",
//     fontWeight: "700",
//     color: "white",
//     border: "none",
//     borderRadius: "14px",
//     cursor: "pointer",
//     minWidth: "220px",
//     transition: "0.3s",
//   },
// };
